var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCompanyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5V1.5H6V3.5H11V10.5H1ZM2 9.5H3V8.5H2V9.5ZM2 7.5H3V6.5H2V7.5ZM2 5.5H3V4.5H2V5.5ZM2 3.5H3V2.5H2V3.5ZM4 9.5H5V8.5H4V9.5ZM4 7.5H5V6.5H4V7.5ZM4 5.5H5V4.5H4V5.5ZM4 3.5H5V2.5H4V3.5ZM6 9.5H10V4.5H6V5.5H7V6.5H6V7.5H7V8.5H6V9.5ZM8 6.5V5.5H9V6.5H8ZM8 8.5V7.5H9V8.5H8Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCompanyInfo);
export default __webpack_public_path__ + "static/media/icons-company-info.4eb1a4ad.svg";
export { ForwardRef as ReactComponent };